import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Daily Marketing Tips - Elm Street</title>
        <meta name="description" content="Sign Up For Our Daily Marketing Tips - Elm Street" />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/daily_marketing_tips" />
        <meta property="og:title" content="Daily Marketing Tips - Elm Street" />
        <meta property="og:description" content="Sign Up For Our Daily Marketing Tips - Elm Street" />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('tipsbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "350px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>Daily</span> Marketing Tips
                  </Typography>
                  <p>A Daily Dose of Marketing Awesomeness...direct to your inbox.</p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div style={{ paddingTop: "65px", paddingBottom: "65px", textAlign: "center" }}>
        <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <Grid container spacing={8} justifyContent="center">
            <Grid item md={12}>
                <strong>
                Every morning, we'll send you a tip, trick or insight
                <br />
                to inspire your inner marketing genius.
              </strong>
            </Grid>
            <Grid item md={8} sm={12} xs={12}>
            <DemoForm
              buttonText="Subscribe Today"
              successMsg={<div style={{color: "#d37800"}}><strong>Thank you for subscribing!</strong><br/><br/>Be sure to check your inbox for your next tip tomorrow.</div>}
              formName="es2_daily_tips" listId="118042"
              fieldList={["first_name", "last_name", "email", "roll"]}
            />
              
            </Grid>
          </Grid>
          
          
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
